import React, { useState } from "react";

/**
 * Delivery.
 *
 * Delivery is a flat $200 unless this job overrides it. That is the whole
 * model — there is no mileage/fuel/driver-hours calculation behind it.
 *
 * Until August 2026 this panel showed seven inputs (Driver Burden, Truck MPG,
 * Fuel Price, PM per mile, Round Trip Miles, Tolls, Est. Delivery Hours) that
 * fed NOTHING: no engine reads any of them, so an estimator could type a
 * 300-mile round trip and watch the quote not move. They are gone. The state
 * fields stay in the reducer so saved JobVersions keep loading, but no screen
 * offers them any more; if per-mile delivery costing is ever wanted, it gets
 * built in the engine first and surfaced second.
 *
 * The $200 is stated on the panel rather than left to be discovered, because a
 * default nobody sees is a default nobody questions.
 */

export const DEFAULT_DELIVERY_FEE_TEXT = "$200";

function DeliverySection({ formData, dispatch, FormInput }) {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  const hasOverride =
    formData.delivery_override !== null &&
    formData.delivery_override !== undefined &&
    formData.delivery_override !== "";

  return (
    <fieldset>
      <legend
        onClick={toggleCollapse}
        style={{
          cursor: "pointer",
          userSelect: "none",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <span
          style={{
            transform: isCollapsed ? "rotate(-90deg)" : "rotate(0deg)",
            transition: "transform 0.2s ease",
            fontSize: "12px",
          }}
        >
          ▼
        </span>
        Delivery Costs
      </legend>
      {!isCollapsed && (
        <div>
          <p
            style={{
              fontSize: "0.95rem",
              fontWeight: 600,
              marginTop: "0.5rem",
              marginBottom: "0.25rem",
            }}
          >
            {hasOverride
              ? `Delivery ${DEFAULT_DELIVERY_FEE_TEXT} (default) — overridden below`
              : `Delivery ${DEFAULT_DELIVERY_FEE_TEXT} (default)`}
          </p>
          <p
            style={{
              fontSize: "0.9rem",
              color: "var(--text-muted, #666)",
              marginTop: 0,
              marginBottom: "0.75rem",
            }}
          >
            Every job carries the flat delivery fee. Enter an override only when
            this job needs a different amount — nothing else on the estimate
            changes delivery.
          </p>
          <FormInput
            label="Delivery Override ($ - Optional)"
            field="delivery_override"
            value={formData.delivery_override}
            dispatch={dispatch}
            type="number"
            step="0.5"
          />
        </div>
      )}
    </fieldset>
  );
}

export default DeliverySection;
